import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/batch_run/delivery/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'Delivery date', value: 'delivery_date', sortable: true, filterable: true, divider: true,},
        {text: 'Customer order', value: 'customer_order_title', sortable: true, filterable: true, divider: true,},
        {text: 'Customer', value: 'customer_title', sortable: true, filterable: true, divider: true,},

        {text: 'Status delivery', value: 'status_delivery', sortable: true, filterable: true, divider: true,},
        {text: 'Quantity', value: 'quantity', sortable: true, filterable: true, divider: true,},
        {text: 'Min SMD', value: 'min_smd', sortable: true, filterable: true, divider: true,},
        {text: 'Max SMD', value: 'max_smd', sortable: true, filterable: true, divider: true,},
        {text: 'Min THT', value: 'min_tht', sortable: true, filterable: true, divider: true,},
        {text: 'Max THT', value: 'max_tht', sortable: true, filterable: true, divider: true,},
        {text: 'S/N from', value: 'sn_from', sortable: true, filterable: true, divider: true,},
        {text: 'S/N to', value: 'sn_to', sortable: true, filterable: true, divider: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true,},
        {text: 'Edited by*', value: 'edited_by_name', sortable: true, divider: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
    statusDelivery: [
        {name: 'Vorbereitung', color: 'grey lighten-5'},
        {name: 'In Klärung', color: 'red lighten-5'},
        {name: 'Produktion', color: 'blue lighten-5'},
        {name: 'Lager', color: 'light-green lighten-5'},
        {name: 'Komplett ausgeliefert', color: 'grey lighten-5'},
        {name: 'Zurückgezogen', color: 'amber lighten-5'},
    ],
    statusBatchRun: [
        {name: 'Vorbereitung', color: 'grey lighten-5'},
        {name: 'In Klärung', color: 'red lighten-5'},
        {name: 'Produktion', color: 'blue lighten-5'},
        {name: 'Lager', color: 'light-green lighten-5'},
        {name: 'Komplett ausgeliefert', color: 'grey lighten-5'},
        {name: 'Zurückgezogen', color: 'amber lighten-5'},
    ],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
    getStatusCustomerOrder(state) {
        let result = []
        // for (let row of state.statusCustomerOrder)
        //     result.push(row.name)
        return result
    }
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        DeliveryTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}